<avano-button-bar-button *ngFor="let buttonDetails of expandCollapseButtons" [buttonDetails]="buttonDetails"></avano-button-bar-button>
